import React from 'react';

import { FormattedMessage } from '@/utils/i18n';

import { Account } from '@/types/planning';

type UseTableMenuItemsProps = {
  i18nBasePath: string;
  onRemovePlanAccount: (selectedPlanAccount?: Account) => void;
};

export const useTableMenuItems = ({ i18nBasePath, onRemovePlanAccount }: UseTableMenuItemsProps) => {
  const menuItems = [
    {
      key: 'delete-account',
      className: 'delete-account destructive',
      icon: 'icon-ds-remove-circle-outline',
      value: <FormattedMessage id={`${i18nBasePath}.Table.MenuItems.DeleteOne`} />,
      onClick: onRemovePlanAccount,
      isAllowed: () => true,
    },
  ];

  return {
    menuItems,
  };
};
